import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";
import "./Header.css";

const Header = () => {
  const { cart } = useCart();

  const tableNo = localStorage.getItem("tableNo");

  return (
    <header className="header">
      {/* LEFT */}
      <div className="header-left">
        <i className="iconly-Category icli menu-icon"></i>

        <Link to="/" className="logo-wrap">
          <img className="logo" src="/assets/images/logo/logo.png" alt="logo" />
        </Link>
      </div>

      {/* CENTER */}
      {/* <div className="header-center">
        <div className="table-badge">🍽️ Table {name || "N/A"}</div>
      </div> */}

      {/* RIGHT */}
      <div className="header-right">
        <div className="time-badge">
          🕒{" "}
          {new Date().toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          })}
        </div>

        <div className="cart-icon">
          <Link to="/cart" className="cart-icon">
            🛒
            {cart?.length > 0 && (
              <span className="cart-badge">{cart.length}</span>
            )}
          </Link>
        </div>

        {/* <img
          className="avatar"
          src="/assets/images/avatar/avatar.jpg"
          alt="avatar"
        /> */}
      </div>
    </header>
  );
};

export default Header;
